/**
 * 模块: 预设对比组件
 * 职责: 可视化对比不同预设的权重分配策略
 * 限制: <150行
 */

import React from 'react';
import { Select, Card, Spin, Tag, Row, Col } from 'antd';
import type { PresetListItem } from '../../../services/configPresetAPI';
import { usePresetComparison } from './PresetComparison/usePresetComparison';
import { ComparisonTable } from './PresetComparison/ComparisonTable';

const { Option } = Select;

interface PresetComparisonProps {
  presets: PresetListItem[];
}

export const PresetComparison: React.FC<PresetComparisonProps> = ({ presets }) => {
  const {
    loading,
    weightsSummary,
    selectedPresets,
    setSelectedPresets,
    tableData,
  } = usePresetComparison();

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 0' }}>
        <Spin size="large" tip="加载对比数据中..." />
      </div>
    );
  }

  return (
    <div className="preset-comparison">
      <Card title="预设策略对比" bordered={false}>
        <div className="comparison-header">
          <p className="section-desc">
            选择多个预设策略，对比它们在各个指标维度上的权重分配差异。
            <Tag color="green" style={{ marginLeft: 8 }}>绿色</Tag> 表示该维度权重最高，
            <Tag color="red">红色</Tag> 表示权重最低。
          </p>

          <div className="preset-selector">
            <label style={{ marginRight: 12, fontWeight: 500 }}>选择对比预设：</label>
            <Select
              mode="multiple"
              style={{ width: '100%', maxWidth: 600 }}
              placeholder="选择2-4个预设进行对比"
              value={selectedPresets}
              onChange={setSelectedPresets}
              maxTagCount="responsive"
            >
              {presets.map((preset) => (
                <Option key={preset.key} value={preset.key}>
                  {preset.name} - {preset.description}
                </Option>
              ))}
            </Select>
          </div>
        </div>

        {/* 对比表格 */}
        <ComparisonTable
          tableData={tableData}
          selectedPresets={selectedPresets}
          presets={presets}
        />

        {/* 预设说明卡片 */}
        <Row gutter={16} style={{ marginTop: 24 }}>
          {selectedPresets.map((presetKey) => {
            const presetInfo = weightsSummary?.presets[presetKey];
            if (!presetInfo) return null;

            return (
              <Col span={24 / selectedPresets.length} key={presetKey}>
                <Card size="small" title={presetInfo.name}>
                  <p style={{ color: '#666', fontSize: 13 }}>{presetInfo.description}</p>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
};
